import React, { useState, useEffect } from 'react';
import Button from '../../../../app/components/Button';
import Table from '../../../../app/components/Table';
import FormEditList from '../../../../forms/FormsListOfOrders/FormEditList';
import { FiEdit, FiTrash2 } from 'react-icons/fi';
import FormServiceDelete from '../../../../forms/FormsListOfOrders/FormServiceDelete';
import Toast from '../../../../app/components/Toast';
import DropdownActions from '../../../../app/components/DropdownActions';
import { usePageTitle } from '../../../../contexts/PageTitleContext';

const ListOfOrders = () => {
  const { setTitle } = usePageTitle();
            
  useEffect(() => {
    setTitle('Lista de Ordens de Serviço');
  }, [setTitle]);
  
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectOrder, setSelectOrder] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [isDeleteFormOpen, setIsDeleteFormOpen] = useState(false);
  const [toast, setToast] = useState({ show: false, type: 'success', message: '' });

  const columns = [
    { campo: 'nome', titulo: 'Nome' },
    { campo: 'sequencia', titulo: 'Sequencia' },
    { campo: 'departamento', titulo: 'Departamento' },
    { campo: 'nivel', titulo: 'Nível' },
    { campo: 'prazo_interno', titulo: 'Prazo Interno' },
    { campo: 'vencimento', titulo: 'Vencimento' },
    { campo: 'envia_email', titulo: 'Envia Email' },
    { campo: 'envia_whatsapp', titulo: 'Envia Whatsapp' },
    { campo: 'passivel_multa', titulo: 'Passível De Multa' },
    { campo: 'recorrente', titulo: 'Recorrente' },
    { campo: 'acoes', titulo: 'Ações', centralizado: true, },
  ];

  const [dataServices, setDataServices] = useState([
    { id: 1, nome: 'Bug Crítico', sequencia: '26', departamento: 3, nivel: 1, prazo_interno: '6h', vencimento: '6h', envia_email: 'Não', envia_whatsapp: 'Não', passivel_multa: 'Não', recorrente: 'Não' },
    { id: 2, nome: 'Bug Urgente', sequencia: 26, departamento: 3, nivel: 2, prazo_interno: '12h', vencimento: '12h', envia_email: 'Não', envia_whatsapp: 'Não', passivel_multa: 'Não', recorrente: 'Não' },
    { id: 3, nome: 'Melhoria Rápida', sequencia: 26, departamento: 3, nivel: 1, prazo_interno: '6h', vencimento: '6h', envia_email: 'Não', envia_whatsapp: 'Não', passivel_multa: 'Não', recorrente: 'Não' },
    { id: 4, nome: 'Melhoria Funcionalidades', sequencia: 26, departamento: 3, nivel: 2, prazo_interno: '12h', vencimento: '12h', envia_email: 'Não', envia_whatsapp: 'Não', passivel_multa: 'Não', recorrente: 'Não' },
  ]);

  const showToast = (type, message) => {
    setToast({ show: true, type, message });
  };

  const filteredData = dataServices.filter((item) =>
    item.nome.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleRowClick = (item) => {
    setSelectOrder(item);
    setEditModalOpen(true);
  };

  const handleDeleteItem = (item) => {
    setSelectOrder(item);
    setIsDeleteFormOpen(true);
  };

  const handleConfirmDelete = () => {
    try {
      if (selectOrder && selectOrder.id) {
        setDataServices((prevOrders) =>
          prevOrders.filter((order) => order.id !== selectOrder.id)
        );
        showToast('success', 'Ordem de serviço excluída com sucesso!');
      } else {
        throw new Error('Erro ao excluir: Ordem de serviço inválida.');
      }
    } catch (error) {
      showToast('error', error.message || 'Erro ao excluir a ordem de serviço.');
    } finally {
      setIsDeleteFormOpen(false);
    }
  };

  const handleEditSubmit = (updatedOrder) => {
    try {
      if (updatedOrder.id) {
        setDataServices((prevOrders) =>
          prevOrders.map((order) =>
            order.id === updatedOrder.id ? updatedOrder : order
          )
        );
        showToast('success', 'Ordem de serviço atualizada com sucesso!');
      } else {
        const newId = dataServices.length > 0 ? Math.max(...dataServices.map((o) => o.id)) + 1 : 1;
        const newOrder = { ...updatedOrder, id: newId };
        setDataServices((prevOrders) => [...prevOrders, newOrder]);
        showToast('success', 'Nova ordem de serviço adicionada com sucesso!');
      }
    } catch (error) {
      showToast('error', 'Erro ao salvar a ordem de serviço.');
    }
    setEditModalOpen(false);
  };

  const handleAddClick = () => {
    setSelectOrder(null);
    setEditModalOpen(true);
  };

  const handleCloseDeleteForm = () => {
    setIsDeleteFormOpen(false);
  };

  const dataServicesWithActions = filteredData.map((item) => ({
    ...item,
    acoes: (
      <div className="flex justify-center">
        <DropdownActions
          actions={[
            {
              label: 'Editar',
              icon: FiEdit,
              onClick: () => handleRowClick(item),
            },
            {
              label: 'Excluir',
              icon: FiTrash2,
              onClick: () => handleDeleteItem(item),
            },
          ]}
        />
      </div>
    ),
  }));

  return (
    <div>
      <div className="flex mb-6">
        <Button
          onClick={handleAddClick}
        >
          Nova Ordem de Serviço
        </Button>
      </div>

      <div className="mt-2 bg-white p-2 rounded-2xl">
        <Table colunas={columns} dados={dataServicesWithActions} />
      </div>

      <FormEditList
        isOpen={editModalOpen}
        onClose={() => setEditModalOpen(false)}
        title={selectOrder ? 'Editar Ordem de Serviço' : 'Nova Ordem de Serviço'}
        onSubmit={handleEditSubmit}
        selectOrder={selectOrder}
      />

      <FormServiceDelete
        isOpen={isDeleteFormOpen}
        onClose={handleCloseDeleteForm}
        onConfirm={handleConfirmDelete}
        order={selectOrder}
      />

      {toast.show && (
        <Toast
          type={toast.type}
          message={toast.message}
          duration={3000}
          onClose={() => setToast({ ...toast, show: false })}
        />
      )}
    </div>
  );
};

export default ListOfOrders;
